import { useRef, useState } from 'react';

import { MenuOutlined, QrcodeOutlined, SearchOutlined } from '@ant-design/icons';
import { Drawer } from 'antd';

import DrawerContent from 'components/Pages/Admin/CheckinPage/QrCodeScanner/Header/DrawerContent';
import { StaffUser } from 'components/Pages/Admin/CheckinPage/QrCodeScanner/types';
import { BlinketSmallLogo } from 'components/Shared/Icons';

import styles from './styles.module.css';
import CheckinHistoryModal from '../../CheckinsHistoryModal';

type HeaderProps = {
  staffToken: string;
  staffUser: StaffUser | null;
  loading: boolean;
  manualCheckin: boolean;
  changeCheckin: () => void;
  updateStaffUser: () => void;
  openManualCheckin: () => void;
  clearScanContent: () => void;
};

const Header = ({
  staffToken,
  staffUser,
  loading,
  manualCheckin,
  changeCheckin,
  updateStaffUser,
  openManualCheckin,
  clearScanContent
}: HeaderProps) => {
  const [openMenu, setOpenMenu] = useState(false);
  const [checkinHistoryVisible, setCheckinHistoryVisible] = useState(false);
  const ref = useRef<HTMLDivElement | null>(null);

  const openDrawer = () => {
    setOpenMenu(true);
    updateStaffUser();
  };

  const closeDrawer = () => {
    setOpenMenu(false);
  };

  const handleOpenCheckinHistoryModal = () => {
    setCheckinHistoryVisible(true);
    closeDrawer();
  };

  const handleCloseCheckinHistory = () => {
    setCheckinHistoryVisible(false);
    clearScanContent();
    updateStaffUser();
  };

  return (
    <>
      <div className={styles.container} ref={ref}>
        <BlinketSmallLogo />
        {!manualCheckin && (
          <button
            className={styles.button}
            onClick={() => {
              changeCheckin();
              clearScanContent();
            }}
          >
            <SearchOutlined /> Fazer Check-in Manual
          </button>
        )}
        {manualCheckin && (
          <button
            className={styles.button}
            onClick={() => {
              changeCheckin();
              clearScanContent();
            }}
          >
            <QrcodeOutlined /> Abrir Leitor QR Code
          </button>
        )}
        <MenuOutlined onClick={openDrawer} />

        <Drawer
          onClose={closeDrawer}
          open={openMenu}
          placement='top'
          extra={<BlinketSmallLogo />}
          getContainer={ref.current}
          classNames={{
            header: styles.drawerHeader,
            wrapper: styles.drawerWrapper
          }}
        >
          <DrawerContent
            staffUser={staffUser}
            loading={loading}
            onOpenCheckinHistoryModal={handleOpenCheckinHistoryModal}
            hasCheckinHistory={staffUser?.checkins > 0}
            closeDrawer={closeDrawer}
            openManualCheckin={openManualCheckin}
          />
        </Drawer>

        <CheckinHistoryModal
          staffToken={staffToken}
          visible={checkinHistoryVisible}
          onClose={handleCloseCheckinHistory}
        />
      </div>
    </>
  );
};

export default Header;
